{
  "network.title": "Network",
  "network.subtitle.one": "{count} workshop",
  "network.subtitle.other": "{count} workshops",
  "network.nav.overview": "Overview",
  "network.nav.kpi": "Metrics",
  "network.nav.demand": "Demand",
  "network.nav.health": "System health",
  "network.nav.audit": "Audit log",
  "network.error": "We could not load the network data.",
  "network.empty": "Nothing to show for this selection.",
  "network.readonly": "Read-only. Anything changed here is done by signing in as someone at the workshop.",
  "network.data_as_of": "Figures last recomputed {when}",
  "network.data_as_of.never": "Figures have not been computed yet",
  "network.data_as_of.hint": "Recomputed every hour.",
  "network.filter.country": "Country",
  "network.filter.country.all": "All countries",
  "network.filter.franchise": "Workshop",
  "network.filter.franchise.all": "All workshops",
  "network.filter.service": "Service",
  "network.filter.service.all": "All services",
  "network.filter.range": "Period",
  "network.filter.reset": "Clear filters",
  "network.range.7": "7 days",
  "network.range.30": "30 days",
  "network.range.90": "90 days",
  "network.range.365": "12 months",
  "network.compared_to": "Compared with {from} – {to}",
  "network.export": "Export CSV",
  "network.export.hint": "Opens in Excel with the active filters applied.",
  "network.map.title": "Map",
  "network.map.planned": "Planned market",
  "network.map.locations.one": "{count} workshop",
  "network.map.locations.other": "{count} workshops",
  "network.map.legend": "Colour shows today's load. A ring around the dot means an open alert.",
  "network.column.next_open": "Next open day",
  "network.column.alerts": "Alerts",
  "network.location.load": "{booked} of {capacity} h booked today",
  "network.location.no_capacity": "Closed today",
  "network.location.next_open": "Next open day {date}",
  "network.location.next_open.none": "Fully booked as far as we can see",
  "network.location.open": "Open the workshop",
  "network.alert.integration_degraded": "Calendar sync down",
  "network.alert.notifications_failing": "Messages failing",
  "network.alert.awaiting_approval": "Awaiting confirmation",
  "network.alert.overbooked": "Overbooked",
  "network.alerts.none": "No alerts",
  "network.metric.bookings": "Bookings",
  "network.metric.revenue": "Revenue",
  "network.metric.utilisation": "Utilisation",
  "network.metric.no_show_rate": "No-shows",
  "network.metric.cancellation_rate": "Cancellations",
  "network.metric.lead_time": "Lead time",
  "network.metric.job_value": "Average job value",
  "network.metric.first_response": "Assessment response time",
  "network.metric.not_applicable": "Cannot be computed per service",
  "network.metric.no_data": "No data",
  "network.delta.better": "{value} better than the previous period",
  "network.delta.worse": "{value} worse than the previous period",
  "network.delta.flat": "Unchanged from the previous period",
  "network.delta.none": "No comparison",
  "network.chart.title": "{metric} per day",
  "network.chart.current": "Selected period",
  "network.chart.previous": "Previous period",
  "network.chart.table": "Show as a table",
  "network.chart.date": "Date",
  "network.league.title": "League table",
  "network.league.metric": "Sort by",
  "network.league.column.rank": "Rank",
  "network.league.column.name": "Workshop",
  "network.league.column.country": "Country",
  "network.league.column.value": "Value",
  "network.league.column.trend": "Trend",
  "network.league.column.delta": "Change",
  "network.demand.title": "Demand map",
  "network.demand.hint": "Input for where the next workshop should open. Contains no personal data.",
  "network.demand.postcodes": "By postcode",
  "network.demand.services": "By service",
  "network.demand.unservable": "Could not be booked anywhere",
  "network.demand.unservable.hint": "A request no workshop could serve has no country, so this list is shown to HQ only.",
  "network.demand.column.postcode": "Postcode",
  "network.demand.column.attempts": "Attempts",
  "network.demand.column.matched": "Matched",
  "network.demand.column.unservable": "No workshop",
  "network.demand.column.converted": "Booked",
  "network.demand.column.service": "Service",
  "network.demand.column.no_slot": "No time",
  "network.demand.column.nearest": "Nearest workshop",
  "network.demand.column.distance": "Distance",
  "network.demand.column.last_seen": "Last seen",
  "network.health.delivery": "Email delivery",
  "network.health.delivery_rate": "Delivered",
  "network.health.sent": "Sent",
  "network.health.failed": "Failed",
  "network.health.pending": "Pending",
  "network.health.bounced": "Bounced",
  "network.health.window_24h": "Last 24 hours",
  "network.health.window_7d": "Last week",
  "network.health.queues": "Queues",
  "network.health.queues.unavailable": "The queue cannot be read from here. See docs/DEPLOYMENT.md.",
  "network.health.queues.hidden": "Queues are network-wide and are shown to HQ only.",
  "network.health.integrations": "Integrations per workshop",
  "network.health.integrations.none": "No calendars connected yet.",
  "network.health.api": "API",
  "network.health.api.caveat": "Counted in memory, per process, since {since}. Resets on every deploy.",
  "network.health.api.requests": "Requests",
  "network.health.api.error_rate": "Error rate",
  "network.health.api.slowest": "Slowest routes",
  "network.health.failed_jobs": "Failed messages",
  "network.health.column.queue": "Queue",
  "network.health.column.route": "Route",
  "network.health.column.p95": "p95",
  "network.health.column.attempts": "Attempts",
  "network.health.column.error": "Error",
  "network.health.all_clear": "Nothing to act on.",
  "network.audit.filter.entity": "Entity",
  "network.audit.filter.action": "Action",
  "network.audit.filter.all": "All",
  "network.audit.column.when": "When",
  "network.audit.column.action": "Action",
  "network.audit.column.entity": "Entity",
  "network.audit.column.actor": "Actor",
  "network.audit.column.franchise": "Workshop",
  "network.audit.column.ip": "IP",
  "network.audit.impersonated": "via {email}",
  "network.audit.system": "The system",
  "network.audit.more": "Show more",
  "network.detail.settings": "Settings",
  "network.detail.staff": "Staff and resources",
  "network.detail.notifications": "Messages, 30 days",
  "network.detail.integrations": "Integrations",
  "network.detail.hours": "Opening hours",
  "network.detail.closed": "Closed",
  "network.detail.confirm.auto": "Confirmed automatically",
  "network.detail.confirm.manual": "Confirmed manually",
  "network.detail.notice": "Minimum notice",
  "network.detail.horizon": "Bookable {days} days ahead",
  "network.detail.granularity": "Slot step {minutes} min",
  "network.detail.cancellation": "Cancellable until {hours} h before",
  "network.detail.services": "{enabled} of {total} services enabled",
  "network.detail.calendar": "Open the calendar",
  "network.detail.back": "Back to the network",
  "network.detail.no_staff": "No staff added yet.",
  "network.create.open": "New workshop",
  "network.create.title": "Add a workshop",
  "network.create.body": "Timezone, language and currency follow from the country. The workshop is created as onboarding and does not appear in booking until it is activated.",
  "network.create.identity": "The workshop",
  "network.create.identity_body": "The name customers see, and the details the emails and invoices are built on.",
  "network.create.place": "Place",
  "network.create.place_body": "Where the customer meets the workshop — on the map and in the nearest-workshop search.",
  "network.create.optional": "optional",
  "network.create.country": "Country",
  "network.create.country_hint": "Sets timezone, language and currency. It cannot be changed afterwards.",
  "network.create.display_name_hint": "The name the customer sees in booking, on the map and in the emails.",
  "network.create.slug": "URL name",
  "network.create.slug_hint": "It is in the booking link and in every email already sent. Get it right the first time.",
  "network.create.slug_preview": "The booking link becomes /boka/{slug} and cannot be changed afterwards.",
  "network.create.legal_name": "Legal name",
  "network.create.legal_name_hint": "The company name. Never shown to the customer.",
  "network.create.org_nr": "Company number",
  "network.create.mode": "Type of operation",
  "network.create.mode.fixed": "Fixed workshop",
  "network.create.mode.mobile": "Mobile",
  "network.create.mode.hybrid": "Both fixed and mobile",
  "network.create.mode_hint.fixed": "The customer comes here. The street address is required.",
  "network.create.mode_hint.mobile": "The technician travels to the customer. The address is the base and is optional — the radius below decides who can book.",
  "network.create.mode_hint.hybrid": "The customer can come here and the technician can travel out. The radius below decides how far you travel.",
  "network.create.geo": "Coordinates",
  "network.create.geo_hint": "Paste both numbers at once into Latitude and we will split them. We do not look up addresses — the map and the nearest-workshop search are built on these two numbers.",
  "network.create.hours_copy": "Copy {day} to every open day",
  "network.create.missing": "Still to fill in:",
  "network.create.services_note": "The whole service catalog is enabled at network prices. The workshop adjusts it afterwards.",
  "network.create.submit": "Add the workshop",
  "network.create.created": "{name} is created. Invite the owner and activate it once everything is right.",
  "network.create.error": "We could not create the workshop.",
  "network.create.slug_taken": "That URL name is taken.",
  "network.create.check_fields": "Check the highlighted fields.",
  "network.create.invalid": "Check this field.",
  "network.create.slug_format": "Only a–z, 0–9 and hyphens. No accented letters or spaces.",
  "network.unit.hours": "{count} h",
  "network.unit.minutes": "{count} min",
  "network.unit.days": "{count} d",
  "network.unit.percent": "{value} %",
  "network.status.onboarding": "Onboarding",
  "network.status.paused": "The workshop has been removed from booking.",
  "network.status.paused_with_bookings": "The workshop has been removed from booking. {count} booked appointments remain and need handling.",
  "network.status.activated": "The workshop is live and appears in booking.",
  "network.status.activate": "Activate the workshop",
  "network.status.needs_staff": "Add at least one bookable person or unit before activating the workshop.",
  "network.status.error": "We could not change the status.",
  "network.danger.title": "Danger zone",
  "network.danger.body": "Remove the workshop from booking. It disappears from the location finder and cannot be booked, but its calendar, history and figures stay.",
  "network.danger.paused_body": "The workshop has been removed from booking. Activate it again when it should take customers.",
  "network.danger.remove": "Remove from booking",
  "network.danger.confirm_title": "Remove the workshop from booking?",
  "network.danger.confirm_body": "Customers can no longer find or book this workshop. Appointments already booked are not cancelled — call those customers. Nothing is deleted, and you can activate the workshop again.",
  "network.danger.type_slug": "Type {slug} to confirm",
  "network.status.removed": "Removed from booking",
  "network.danger.copy_slug": "Copy {slug}",
  "network.danger.copied": "The name is copied.",
  "network.column.status": "Status",
  "network.status.active": "Live",
  "network.reports.title": "Reports for you",
  "network.reports.body": "Have the network's or a country's figures emailed automatically.",
  "network.reports.scope": "Scope",
  "network.reports.scope.network": "The whole network",
  "network.reports.self_only": "The report is sent to your own address.",
  "network.nav.reports": "Reports",
  "network.nav.integrations": "Integrations",
  "network.integrations.body": "Providers the workshops can choose for customer reminders. Only HQ sees the keys, and only HQ pays.",
  "network.integrations.unavailable": "Messaging is not switched on in this environment.",
  "network.integrations.email.managed": "Resend · Managed by ColorGlo HQ",
  "network.integrations.elks46.username": "API username",
  "network.integrations.elks46.password": "API password",
  "network.integrations.elks46.sender.hint": "3–11 letters or digits, no spaces, starting with a letter, for example ColorGlo. Used when the workshop has not set its own sender name.",
  "network.integrations.hint": "Key ••••{hint}",
  "network.integrations.used_by.one": "Used by {count} workshop",
  "network.integrations.used_by.other": "Used by {count} workshops",
  "network.integrations.enabled": "Available to workshops",
  "network.integrations.enabled.needs_verify": "Test the connection before the provider can be switched on.",
  "network.integrations.verify": "Test connection",
  "network.integrations.verified": "The connection works.",
  "network.integrations.send_test": "Send test to me",
  "network.integrations.test_sent": "The test message is sent.",
  "network.integrations.replace": "Replace keys",
  "network.integrations.replace.hint": "The provider is switched off until the new key has been tested.",
  "network.integrations.saved": "Saved.",
  "network.integrations.failure.credentials_rejected": "The provider did not accept the keys.",
  "network.integrations.failure.unreachable": "The provider did not answer. Try again in a moment.",
  "network.integrations.failure.unexpected": "Something went wrong at the provider.",
  "network.integrations.test_phone": "Mobile number for the test",
  "network.integrations.test_phone.hint": "With country code, for example +46701234567.",
  "network.integrations.test_dry_run": "Test mode: no SMS was sent and nothing was charged. Set SMS_REDIRECT_TO to receive real test messages.",
  "network.integrations.field.sender": "Default sender",
  "network.integrations.field.sender.optional": "Optional. 3–11 letters or digits. Must be approved on your Prelude account. Leave empty for the account default.",
  "network.integrations.field.api_key": "API key",
  "network.integrations.field.test_template_id": "Template ID for the test message",
  "network.integrations.field.test_template_id.hint": "A template without variables, for example template_01k8…. Ask Prelude to create it.",
  "network.integrations.field.access_token": "Access token (permanent system user token)",
  "network.integrations.field.phone_number_id": "Phone number ID",
  "network.integrations.field.phone_number_id.hint": "The digits under WhatsApp → API Setup in Meta, not the phone number itself.",
  "network.integrations.field.test_template_name": "Template for the test message",
  "network.integrations.field.test_template_name.hint": "hello_world exists in every WhatsApp account from the start.",
  "network.integrations.field.test_template_language": "Template language code",
  "network.integrations.field.template.booking_confirmed": "Template ID: booking confirmation (colorglo_booking_confirmed)",
  "network.integrations.field.template.reminder": "Template ID: reminder (colorglo_reminder)",
  "network.integrations.field.template.rescheduled": "Template ID: moved appointment (colorglo_rescheduled)",
  "network.integrations.field.template.cancelled": "Template ID: cancelled appointment (colorglo_cancelled)",
  "network.integrations.field.template.hint": "From Prelude once the templates in docs/messaging/prelude-templates.csv are uploaded. Without an ID, that kind of message is not sent.",
  "network.nav.costs": "Costs",
  "network.costs.title": "Message costs",
  "network.costs.body": "SMS and WhatsApp per workshop and month. Only HQ sees this page. Amounts in different currencies are never added together.",
  "network.costs.previous": "Previous month",
  "network.costs.next": "Next month",
  "network.costs.sent": "Sent",
  "network.costs.failed": "Failed",
  "network.costs.skipped": "Skipped",
  "network.costs.cost": "Cost",
  "network.costs.total": "Total {currency}",
  "network.costs.workshop": "Workshop",
  "network.costs.provider": "Provider",
  "network.costs.paused": "Switched off",
  "network.costs.empty": "No SMS or WhatsApp messages this month.",
  "network.costs.without_cost": "{count} without a reported cost",
  "network.integrations.field.account_sid": "Account SID",
  "network.integrations.field.auth_token": "Auth Token",
  "network.integrations.field.sender.twilio": "A sender name of 3–11 letters or digits, for example ColorGlo, or a Twilio number with country code (+46…). Used when the workshop has not set its own.",
  "network.owner.title": "Owner",
  "network.owner.description": "The invitation goes to the workshop's own mailbox. The owner only picks a password.",
  "network.owner.state.none": "No owner",
  "network.owner.state.invited": "Invited – expires {date}",
  "network.owner.state.active": "Active",
  "network.owner.send": "Send invitation",
  "network.owner.resend": "Send again",
  "network.owner.revoke": "Withdraw",
  "network.owner.sent": "Invitation sent to {email}",
  "network.owner.link": "This link is shown only now. Share it if the email doesn't arrive.",
  "network.owner.copy": "Copy link",
  "network.owner.copied": "Link copied",
  "network.owner.error": "That didn't work. Try again."
}
